'use strict';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons";
import styles from './socialmedialinks.module.css';
export default function SocialMediaLinks() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.socialMediaLinks,
    children: [/*#__PURE__*/_jsx(Link, {
      href: "https://www.facebook.com/pages/category/American-Restaurant/Lil-Bits-Cafe-125829454148049/",
      children: /*#__PURE__*/_jsx("a", {
        rel: "noreferrer",
        title: "Join us on Facebook!",
        target: "_blank",
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faFacebook,
          width: 40
        })
      })
    }), /*#__PURE__*/_jsx(Link, {
      href: "https://twitter.com/lilbitscafe?lang=en",
      children: /*#__PURE__*/_jsx("a", {
        rel: "noreferrer",
        title: "Follow us on Twitter!",
        target: "_blank",
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faTwitter,
          width: 40
        })
      })
    })]
  });
}